import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CustomScrollbarComponent } from 'src/app/shared/common/components/custom-scrollbar.component';
import { SurveyJob } from 'src/app/shared/survey-data-services/survey-job';
import { SurveyJobService } from 'src/app/shared/survey-data-services/survey-job.services';

@Component({
    selector: 'tabbed-list',
    templateUrl: 'tabbed-list.component.html'
})
export class TabbedListComponent {
    @Input() tabIndex: number = 0;
    @Input() tabs: { label: string; value: string }[] = [];
    @Input() listItems: [] = [];
    @Input() loading: boolean = false;
    @Input() allItemsLoaded: boolean = false;
    @Input() showEndMessage: boolean = true;
    @Input() currentScrollPosition: number = 0;

    @Output() tabIndexChange = new EventEmitter<number>();
    @Output() loadNextPage = new EventEmitter<void>();
    @Output() selectSurveyJob = new EventEmitter<{ job: SurveyJob; scrollPosition: number }>();
    @Output() jobVisibilityToggle = new EventEmitter<SurveyJob>();

    @ViewChild(CustomScrollbarComponent, { static: false })
    customScrollbar: CustomScrollbarComponent;

    downloadingIds: Set<string> = new Set();

    constructor(private surveyJobService: SurveyJobService) {}

    onTabChange(event: number) {
        this.tabIndexChange.emit(event);
    }

    onLoadNextPage() {
        this.loadNextPage.emit();
    }

    onSelectSurveyJob(event: any) {
        if (this.customScrollbar) {
            this.currentScrollPosition = this.customScrollbar.scrollPosition.getValue();
        }
        this.selectSurveyJob.emit({ job: event, scrollPosition: this.currentScrollPosition });
    }

    onJobVisibilityToggle(job: SurveyJob) {
        this.jobVisibilityToggle.emit(job);
    }

    downloadJob(job: SurveyJob) {
        this.downloadingIds.add(job.id);
        this.surveyJobService.downloadJobPackage(job.id).subscribe({
            next: blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${job.name}.zip`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.downloadingIds.delete(job.id);
            },
            error: () => {
                this.downloadingIds.delete(job.id);
            }
        });
    }

    trackByEtag(index: number, item: SurveyJob): string {
        return item.eTag;
    }
}
